'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var icons = require('@tempi/icons');
var ReactPaginate = require('react-paginate');
var getPropsIcon = require('../../../utils/getPropsIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var ReactPaginate__default = /*#__PURE__*/_interopDefaultLegacy(ReactPaginate);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ArticlePagination = (props) => {
  const _a = props, { paginationColor = "#7367f0", textColor = "#000000" } = _a, rest = __objRest(_a, ["paginationColor", "textColor"]);
  const getIcon = (name) => /* @__PURE__ */ jsxRuntime.jsx(icons.Icon, __spreadValues({}, __spreadValues({
    name
  }, getPropsIcon.getPropsIcon({
    color: paginationColor
  }))));
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    $paginationColor: paginationColor,
    $textColor: textColor,
    children: /* @__PURE__ */ jsxRuntime.jsx(ReactPaginate__default["default"], __spreadValues({
      breakLabel: "...",
      nextLabel: getIcon("RightOutlined"),
      pageRangeDisplayed: 1,
      previousLabel: getIcon("LeftOutlined"),
      renderOnZeroPageCount: null
    }, rest))
  });
};
const Wrapper = styled__default["default"].div`
  /* Reset default list styles */
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  /* Pagination styles */
  ul[role='navigation'] {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1em 0;
  }

  ul[role='navigation'] li {
    margin: 0 5px;
  }

  ul[role='navigation'] a {
    display: block;
    padding: 0.25em 0.75em;
    text-decoration: none;
    color: ${(props) => props.$textColor};

    border-radius: 4px;
    cursor: pointer;
  }

  ul[role='navigation'] .selected a {
    color: ${(props) => props.$paginationColor};
    background-color: transparent;
    border: 1px solid ${(props) => props.$paginationColor};
  }

  ul[role='navigation'] .disabled a {
    pointer-events: none;
    color: #d9d9d9;
  }

  /* Arrow styles */
  ul[role='navigation'] a[aria-label='Previous page'],
  ul[role='navigation'] a[aria-label='Next page'] {
    font-weight: bold;
  }

  /* Hover effect */
  ul[role='navigation'] a:hover:not(.disabled) {
    background-color: #ddd;
  }
`;

exports.ArticlePagination = ArticlePagination;
